import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/block-models`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/block-models/${id}`);
  },
  async findAll() {
    return axios.get('/block-models');
  },
  async delete({ id }) {
    return axios.delete(`/block-models/${id}`);
  },
  async update(formData) {
    return axios.put(`/block-models/${formData.id}`, formData);
  }
};
